import { useEffect, useState } from "react";
import Login from "./Login";
import OtpVerifyScreen from "./OtpVerifyScreen";
import ResizeListener1 from "../../../utility/resize";
function LoginIndex() {
  const [step, setStep] = useState(0);
  const [email, setEmail] = useState("");

  return (
    <div>
      {step === 0 ? (
        <Login
          onClick={(data) => {
            setEmail(data);
            setStep(1);
          }}
        />
      ) : (
        <OtpVerifyScreen email={email} />
      )}
    </div>
  );
}

export default LoginIndex;
